import { NotificationsApi } from '../api/NotificationsApi'
import { container } from '../services/container'

export const webview = {
	data: {
		appViewPosition: {
			top: 0,
			bottom: 0
		},

		token: null,

		isTop: null,

		startRouteName: null
	},

	watch: {
		user (newUser, oldUser) {
			if (this.$mq.isWV()) {
				const loginExecuted = () => { 
					return (oldUser === null || oldUser.email.includes('guest.quomi.it'))
						&& !newUser.email.includes('guest.quomi.it')
				}
	            const logoutExecuted = () => { return newUser === null }

	            if (loginExecuted()) {
	            	this.subscribe()
	            	if (this.$route.name  === 'wv-login-page') {
	            		this.$router.push({ name: this.startRouteName && this.startRouteName !== 'wv-login-page' ? this.startRouteName : 'home' })
	            		this.startRouteName = null
	            	}
	            }
	       
	            if (logoutExecuted()) {
	            	this.$router.push({ name: 'wv-login-page' })
	            }
	        }
		}
	},
	computed: {
		routeTitle () {
			if (['dashboard', 'home'].indexOf(this.$route.name) >= 0) return 'Home'
			
			if (['cookbook', 'recipe'].indexOf(this.$route.name) >= 0) return 'Ricettario'
			
			if (['recipes', 'flow-subscribed', 'thank-you-new','shop-by-tag', 'shop'].indexOf(this.$route.name) >= 0) return 'Componi la tua box'


			if (['flow-new'].indexOf(this.$route.name) >= 0) return 'Spedizione e pagamento'

			if (['ecommerce', 'thank-you-recurring'].indexOf(this.$route.name) >= 0) return 'Completa la tua spesa'
			if (['invite-friend'].indexOf(this.$route.name) >= 0) return 'Invita un amico'
			if (['plans'].indexOf(this.$route.name) >= 0) return 'Ordina ora'

			if (this.$route.name.indexOf('profile') >= 0) return 'Profilo' 

			return ''
		}
	},
	methods: {
		updateAppViewPosition (params) {
			if (!params) return
			this.appViewPosition.top = params.top ? params.top : 0
			this.appViewPosition.bottom = params.bottom ? params.bottom : 0
		},

		subscribe () {
			var params = { token: this.token, tokenizable_type: 'user' }
			var nm = new NotificationsApi()
			return nm.subscribe(params)
		},

		unsubscribe () {
			if (!this.$mq.isWV()) return Promise.resolve()
			var params = { token: this.token }
			var nm = new NotificationsApi()
			return nm.unsubscribe(params)
		},

		getTokenFromApp () {
			if (!(typeof Android !== "undefined" && Android !== null)) return

			window.addEventListener("message", (event) => {
				const accessPermitted = () => {
					return event.origin === 'https://quomi.it' || event.origin === 'https://mealk.it:52395'
				}
				if (accessPermitted()) {
					this.token = JSON.parse(event.data).appToken
				}
			})

			Android.getToken()
			// interface for this
			// window.postMessage(JSON.stringify({ appToken: '" + token + "' }))
		},

		touchstart (event) {
			return
			this.isTop = false
			this.touchstart = event.touches[0].pageY
		},
		touchmove (event) {
			return
		    var c = document.documentElement.scrollTop || document.body.scrollTop
		    if (c === 0) {
		    	this.isTop = true
		    }
		},
		touchend (event) {
			return
			this.touchend = event.touches[0].pageY
			if (this.isTop) {
				this.$router.replace({ name: 'invite-friend' })
			}
		},

		redirectHandler () {
			var allowedPagesNames = [
				'sign-in-token',
				'recovery'
			]
			const isPageAllowed = () => allowedPagesNames.indexOf(this.$route.name) >= 0
			if ((!this.user || this.user.email.includes('guest.quomi.it')) && !isPageAllowed()) {
				return this.$router.replace({ name: 'wv-login-page' })
			}
		}
	},
	created () {
		if (container.get('services.cookies').get('auth_token', '/')) {
			this.$router.replace('recovery/password')
		}

		if (!this.$mq.isWV()) return

		this.startRouteName = this.$route.name

		this.getTokenFromApp()
		this.updateAppViewPosition({ top: 45, bottom: 45 })
		this.redirectHandler()
	},
	
	mounted () {
		document.querySelector('#app-view').addEventListener('touchstart', (event) => {
			this.touchstart(event)
		})
		document.querySelector('#app-view').addEventListener('touchmove', (event) => {
			this.touchmove(event)
		})
		document.querySelector('#app-view').addEventListener('touchend', (event) => {
			this.touchend(event)
		})
	}
}